import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Input, Space, Spin, Table } from "antd";
import { partnerApi } from "api/partner.api";
import { Pagination } from "components/Pagination";
import React, { useEffect, useState, useRef } from "react";
import { ModalStatus } from "types/modal";
import { QueryParam } from "types/query";
import { Partner } from "types/partner";
import { getTitle } from "utils";
import { $url } from "utils/url";
import { PartnerModal } from "./PartnerModal";

const { ColumnGroup, Column } = Table;

interface Props {
  shopId: number;
}

export const PartnerTab = ({ shopId }: Props) => {
  const [query, setQuery] = useState<QueryParam>({
    page: 1,
    limit: 10,
    search: "",
    shopId: shopId || null,
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<Partner[]>([]);
  const [total, setTotal] = useState(0);
  const [selectedPartner, setSelectedPartner] = useState<Partial<Partner>>({});
  const modalRef = useRef<PartnerModal>(null);

  useEffect(() => {
    fetchData();
  }, [query]);

  // useEffect(() => {
  //   query.shopId = shopId;
  //   setQuery({ ...query });
  // }, [shopId]);

  const fetchData = async () => {
    setLoading(true);
    const res = await partnerApi.findAll(query);
    setLoading(false);
    setData(res.data.partners);
    setTotal(res.data.total);
  };

  return (
    <div>
      <div className="filter-container">
        <Space>
          <div className="filter-item">
            <label htmlFor="">Tìm kiếm</label>
            <Input
              onKeyDown={(ev) => {
                if (ev.code == "Enter") {
                  query.page = 1;
                  setQuery({ ...query });
                }
              }}
              size="middle"
              onChange={(ev) => {
                query.search = ev.currentTarget.value;
              }}
              placeholder="Tìm kiếm"
            />
          </div>

          <div className="filter-item btn">
            <Button
              onClick={fetchData}
              type="primary"
              icon={<SearchOutlined />}
            >
              Tìm kiếm
            </Button>
          </div>

          <div className="filter-item btn">
            <Button
              onClick={() => {
                modalRef.current?.handleCreate();
              }}
              type="primary"
              icon={<PlusOutlined />}
            >
              Thêm mới
            </Button>
          </div>
        </Space>
      </div>

      <Spin spinning={loading}>
        <Table pagination={false} rowKey="id" dataSource={data}>
          <Column
            title="Logo"
            dataIndex="logo"
            key="logo"
            render={(text, record: Partner) => {
              return (
                <div>
                  {record.logo && (
                    <img
                      width={50}
                      height={50}
                      style={{ objectFit: "cover" }}
                      src={$url(record.logo)}
                      alt=""
                    />
                  )}
                </div>
              );
            }}
          />
          <Column title="Tên" dataIndex="name" key="name" />

          <Column
            title="Action"
            key="action"
            render={(text, record: Partner) => (
              <span>
                <Button
                  type="primary"
                  onClick={() => {
                    modalRef.current?.handleUpdate(record);
                  }}
                >
                  Cập nhật
                </Button>
              </span>
            )}
          />
        </Table>

        <Pagination
          currentPage={query.page}
          total={total}
          onChange={({ limit, page }) => {
            query.page = page;
            query.limit = limit;
            setQuery({ ...query });
          }}
        />
      </Spin>

      <PartnerModal
        onSubmitOk={fetchData}
        shopId={shopId}
        onClose={() => {}}
        ref={modalRef}
      />
    </div>
  );
};
